import { render, staticRenderFns } from "./userAuth.vue?vue&type=template&id=52e6d260"
import script from "./userAuth.vue?vue&type=script&lang=js"
export * from "./userAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports